import { render, staticRenderFns } from "./albumsList.vue?vue&type=template&id=22b59ce6&scoped=true&"
import script from "./albumsList.vue?vue&type=script&lang=ts&"
export * from "./albumsList.vue?vue&type=script&lang=ts&"
import style0 from "./albumsList.vue?vue&type=style&index=0&id=22b59ce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b59ce6",
  null
  
)

export default component.exports